import { SeparatorContainer } from "./Separator.styles";

const Separator = ({ colour='lightgray', hideOnMobile=false }) => {
    return (
        <SeparatorContainer $colour={colour} $hideOnMobile={hideOnMobile}>
            |
        </SeparatorContainer>
    )
};

export default Separator;